import React from 'react';
import { Spin } from 'antd';
import * as PropTypes from 'prop-types';

export default function Loader({ error }) {
  return error ? (
    `Unable load script. ${error.message}. Please try again later.`
  ) : (
    <Spin size="large" data-testid="loader" style={styles.spin}>
      {' '}
      <div style={styles.spinDiv} />
    </Spin>
  );
}

const styles = {
  spin: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto'
  },
  spinDiv: { height: '100vh' }
};

Loader.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired
  })
};
